import { HTMLAttributes } from 'react';

import { cn } from '@app/shared/utils/common';

type GlassCardProps = HTMLAttributes<HTMLDivElement>;

export function GlassCard({ className, ...rest }: GlassCardProps) {
  return (
    <div
      className={cn(
        'cursor-pointer relative overflow-hidden rounded-2xl border-b border-r backdrop-blur-lg border-home-card-border bg-home-card-bg',
        className
      )}
      {...rest}
    />
  );
}

export function GlassCardDot() {
  return <span className="flex size-[11px] shrink-0 rounded-full bg-home-progress-gradient" />;
}

export function GlassCardWithDot(props: GlassCardProps) {
  return (
    <div className="relative">
      <GlassCard {...props} />
      <div className="absolute bottom-0 right-0">
        <GlassCardDot />
      </div>
    </div>
  );
}

export function GlassCardLabel({ className, ...rest }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn(
        'text-2xs font-semibold leading-[1.8] tracking-tight text-home-plus-icon',
        className
      )}
      {...rest}
    />
  );
}
